export enum RouteName {
  DASHBOARD = 'dashboard',
  TICKETS = 'tickets',
  TICKET_DETAILS = 'ticket-details',
  CONTRACTS = 'contracts',
  SITES = 'sites',
  TICKET_BOARD = 'ticket-board',
  READY_FOR_PROCESSING = 'ready-for-processing',
  RECIPE_MANAGEMENT = 'recipe-management',
  ARTICLE_MANAGEMENT = 'article-management',
  CONTRACT_MANAGEMENT = 'contract-management',
}
